import { useState, FormEvent } from 'react';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

const FORM_URL = 'https://readdy.ai/api/form/d705mg67ipaugi04ltg0';

export default function CTAFinal() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) {
      setError('Veuillez entrer votre adresse email.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const body = new URLSearchParams({ email });
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setSubmitted(true);
      } else {
        setError('Une erreur est survenue. Veuillez réessayer.');
      }
    } catch {
      setError('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="cta-final"
      className="relative py-28 lg:py-36 overflow-hidden"
    >
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#6ECFA0] via-[#52BE8A] to-[#3DA872]" />
      {/* Pattern overlay */}
      <div className="absolute inset-0 opacity-10 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjAuNSIvPjwvZz48L3N2Zz4=')]" />
      {/* Radial glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-white/10 rounded-full blur-3xl" />

      <div
        ref={ref}
        className={`relative z-10 max-w-3xl mx-auto px-6 text-center transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <h2 className="text-4xl lg:text-6xl font-black text-white leading-tight mb-4">
          Vous avez un objectif commercial ?
        </h2>
        <p className="text-3xl lg:text-4xl font-black text-black/25 mb-6">
          On s&apos;en charge.
        </p>
        <p className="text-white/80 text-lg mb-12 max-w-lg mx-auto">
          Laissez votre email, on vous rappelle sous 24h pour cadrer votre besoin. Sans engagement, sans blabla.
        </p>

        {!submitted ? (
          <form
            data-readdy-form
            onSubmit={handleSubmit}
            className={`transition-all duration-500 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            <div className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@email.com"
                className="flex-1 bg-white text-[#0A0A0A] text-sm font-medium placeholder-[#999] px-6 py-4 rounded-full outline-none focus:ring-2 focus:ring-black/20 transition-all"
                required
              />
              <button
                type="submit"
                disabled={loading}
                className="bg-[#0A0A0A] hover:bg-[#1A1A1A] text-white font-bold text-sm px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer disabled:opacity-60 flex items-center gap-2 justify-center"
              >
                {loading ? (
                  <i className="ri-loader-4-line animate-spin text-base" />
                ) : (
                  <>
                    Être rappelé
                    <i className="ri-arrow-right-line" />
                  </>
                )}
              </button>
            </div>
            {error && (
              <p className="text-black/60 text-sm mt-3 font-medium">{error}</p>
            )}
            <p className="text-white/60 text-xs mt-4">
              Réponse sous 24h · Sans engagement · 100% confidentiel
            </p>
          </form>
        ) : (
          <div className="bg-white/15 backdrop-blur-sm rounded-2xl px-8 py-6 inline-block">
            <div className="flex items-center gap-3 text-white">
              <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full">
                <i className="ri-check-line text-xl text-white" />
              </div>
              <div className="text-left">
                <p className="font-black text-lg">Message reçu !</p>
                <p className="text-white/70 text-sm">On vous rappelle dans les 24h.</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
